<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-推广海报-添加
    -->
    <el-dialog
    title="添加推广海报"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
     

        <el-form-item label="推广海报名称" prop="name"><el-input v-model="form.name" placeholder="请输入推广海报名称" class="max-w460"></el-input></el-form-item>
      
       
  


      <el-form-item label="推广海报image：" prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.image">
          <transition-group>
            <div v-for="(item, index) in form.image" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'image')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('image')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>
    


      <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       
       
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</el-dialog>
  
</template>

<script>
import AfuncApi from '@/api/afunc.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";

export default {
  components: {
    Upload: Upload,
    draggable
  },
  data() {
    return {
      // 表单数据
      form: {
        name: '',
        code: 'custom',
        image: [],
        bannar: [],
        
        release_time: '',      // 日期字段，使用 value-format 确保格式正确
        place: '',
        ac_intro: '',
        speaker_name: '',
        speaker_intro: '',
        maxnum: 0,            // 数字类型
        cost: 0,              // 数字类型
        rule: '',
        longitude: '',        // 字符串类型，提交时转换为数字
        latitude: '',         // 字符串类型，提交时转换为数字
        tips: '',
        
        sort: 50,             // 数字类型
        intro: ""
      },
      
      loading: false,
      dialogVisible: false,
      isProductUpload: false,
      code: "image",
      
      // 验证规则
      rules: {
        name: [{ required: true, message: '请输入推广海报名称', trigger: 'blur' }],
        cost: [
          { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的金额格式', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
    // 日期选择变化处理
    handleDateChange(value) {
      console.log('日期选择变化:', value);
      // 这里可以添加额外的日期处理逻辑
    },
    
    // 关闭弹窗
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    
    // 提交表单
    async onSubmit() {
      let self = this;
      
      // 验证表单
      self.$refs.form.validate(async valid => {
        if (!valid) {
          self.$message({
            message: '请填写完整的表单信息',
            type: 'warning'
          });
          return;
        }
        
        // 复制表单数据，避免修改原始数据
        let submitData = {...self.form};
        
        // ========== 数据处理部分 ==========
        // 1. 格式化费用为数字
        if (submitData.cost) {
          submitData.cost = parseFloat(submitData.cost) || 0;
        }
        
  
  
        // 5. 确保最大参与人数为数字
        if (submitData.maxnum) {
          submitData.maxnum = parseInt(submitData.maxnum) || 0;
        }
        
        console.log('提交的数据:', submitData);
        
        // 提交数据
        self.loading = true;

          const response = await AfuncApi.call({
          model: 'poster_temp',
          action: 'add',
          ...submitData
        });
        
        if (response.code === 1) {
          this.$message.success(response.msg || '添加成功');
          this.dialogFormVisible("success");
        } else {
          this.$message.error(response.msg || '添加失败');
        }
      });
    },
    
    // 取消添加
    cancelFunc() {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    
    // 打开上传图片
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code;
    },
    
    // 上传商品图片回调
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        
        // 验证图片格式
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1].toLowerCase();
          if (imgExpt.includes(ext)) {
            prevent = true;
          }
        });
        
        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        
        // 根据类型添加到对应的数组
        if (this.code == 'image') {
          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        } else if (this.code == 'bannar') {
          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }
      
      this.isProductUpload = false;
    },
    
    // 删除图片
    deleteImg(index, code) {
      if (code == 'image') {
        this.form.image.splice(index, 1);
      } else if (code == 'bannar') {
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/poster_temp/index/part/add.vue